import { NgFor, NgIf } from '@angular/common';
import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatButtonModule } from '@angular/material/button';
import { EmailConfig } from '../../models/email-config.model';
import { EmailConfigListService } from '../../services/email-config-list.service';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationService } from '../../services/notification.service';
import { getPolishPaginatorIntl } from '../../polish-paginator-intl';
import { MatCardModule } from '@angular/material/card';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalAddEmailConfigComponent } from './modal-add-email-config/modal-add-email-config.component';

@Component({
    selector: 'app-email-config-list',
    standalone: true,
    imports: [
        //NgFor,
        NgIf,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        ReactiveFormsModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonToggleModule,
        MatButtonModule,
        FormsModule,
        MatSlideToggleModule,
        MatCardModule
    ],
    templateUrl: './email-config-list.component.html',
    styleUrl: './email-config-list.component.css',
    providers: [{ provide: MatPaginatorIntl, useValue: getPolishPaginatorIntl() }]
})
export class EmailConfigListComponent  implements OnInit {


  public dialogRef?: MatDialogRef<ModalAddEmailConfigComponent>;

  readonly dialog = inject(MatDialog);


  private _snackBar = inject(MatSnackBar);
  durationInSeconds = 5;

  public rekbotId: number = 0;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  public editForm: FormGroup = new FormGroup({});
  public accounts: EmailConfig[] = [];

  public currentAccount: EmailConfig = {
    id: 0,
    email: "",
    report: 0,
    error: 0,
    alert: 0
  };
  public dataSource = new MatTableDataSource<any>(this.accounts);

  public displayedColumns: string[] = [
    'id', 
    'email', 
    'report', 
    'error', 
    'alert', 
    'action'
  ];

  constructor(
    private modalService: NgbModal,
    private emailSettingsService: EmailConfigListService,
    public router: Router,
    private route: ActivatedRoute,
    private notificationService: NotificationService,
  ) {
    this.currentAccount = new EmailConfig ( 0, "", 0, 0, 0);
  }

  ngOnInit(): void {

      this.rekbotId = this.route.parent?.snapshot.params['rekbotId'];
  
      if (this.rekbotId > 0) {
        this.emailSettingsService.setCurrentRekbotId(this.rekbotId);
        this.fetchEmails();
      }
  }

  fetchEmails() {
    this.emailSettingsService.fetchEmails(this.rekbotId)
    .subscribe({
      next: (response: any) => {

        console.log("fetchEmails", response);
        this.accounts = response.emailList.map( (el: EmailConfig) => {
          return el;
        });

        this.dataSource =  new MatTableDataSource<any>(this.accounts);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

      },
      error: (error) => {
        console.log("fetchSmtpConfig error", error)
        if(error.status === 401) {
          this.router.navigate(['/']);
        }
      }
    });
  }

  onSumbitEmail() {

    if(this.currentAccount.id) {
      this.emailSettingsService.updateEmail(this.rekbotId, this.currentAccount)
      .subscribe({
        next: (response: any) => {
          console.log("subscribe updateEmail", response);
          this.notificationService.pushNotification(
            `Email zaktualizowany`, 'info', 5000);

          this.fetchEmails();
        },
        error: (error) => {
          alert("Wrong data: " + error.error.message);
          if (error.status === 401) {
            this.router.navigate(['/']);
          }
        }
      });
    } else {
      this.emailSettingsService.addEmail(this.rekbotId, this.currentAccount)
      .subscribe({
        next: (response: any) => {
          console.log("subscribe updateEmail", response);

          this.notificationService.pushNotification(
            `Email dodany`, 'info', 5000);

          this.fetchEmails();
        },
        error: (error) => {
          alert("Wrong data: " + error.error.message);
          if (error.status === 401) {
            this.router.navigate(['/']);
          }
        }
      });
    }
  }

  editElement(element: EmailConfig) {
    console.log("editElement", element);

    this.currentAccount = element;
    this.openDialog(element);
  }

  deleteElement(element: EmailConfig) {
    console.log("deleteElement");

    this.emailSettingsService.removeEmail(this.rekbotId, element)
    .subscribe({
      next: (response: any) => {
        console.log("subscribe deleteElement", response);

        this.fetchEmails();
      },
      error: (error) => {
        alert("Wrong data: " + error.error.message);

      }
    });
  }

  public openModal(modal: any, account: EmailConfig) {

    this.currentAccount =  account
    console.log("openModal", this.currentAccount)

    if(account.id) {
      //this.initForm(account)
    } else {
      //this.initForm(this.createSMTP())
    }

    this.modalService.open(modal);
  }

  createEmailEntity() {
    let newAccount = new EmailConfig(0, "", 0,0,0);
    return newAccount;
  }

  initForm(element: EmailConfig) {
    /*this.editForm = new FormGroup({
      id: new FormControl(element.id, [Validators.required]),
      email: new FormControl(element.email, [Validators.required]),
      report: new FormControl(element.report, [Validators.required]),
      error: new FormControl(element.error, [Validators.required]),
      _alert: new FormControl(element._alert, [Validators.required]),
    })*/


  }

  doFilter(event: Event) {
    //let value = filterValue.target.value
    const filterValue = (event.target as HTMLInputElement).value;

    console.log("do filter arg", filterValue)
    this.dataSource.filter = filterValue.trim().toLowerCase()
  }  

  createEmail() {
    console.log("Create email");
    return  new EmailConfig ( 0, "", 0, 0, 0, this.rekbotId);
  }

  openDialog(emailConfig: EmailConfig): void {

    this.emailSettingsService.setCurrentEmail(emailConfig);

    this.dialogRef = this.dialog.open(ModalAddEmailConfigComponent, {
      width: '600px',
      data: emailConfig
    });

    this.dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.fetchEmails();
    });
  }

  addEmail() {
    this.openDialog(this.createEmail());
  }


}

